





























































import Vue from 'vue'
import AppDialog from '~/components/AppDialog.vue'
import ObjectParser from '~/helper/ObjectParser'
import { Role } from '../../../shared/Role'

export default Vue.extend({
  components: {
    AppDialog,
  },
  //value prop is the value of v-model
  props: ['selectedCenter', 'viewOnly', 'value'],
  data: () => ({
    center: { name: 'loading...' },
    Role,
  }),
  watch: {
    // to have child props dynamically change with parent input, watch the prop and assign it to local variable defined in data
    selectedCenter() {
      this.center = this.selectedCenter
    }
  },
  methods: {
    doesCenterHaveEmptyFields() {
      const obj: any = { ...this.center }
      delete obj.province // Province is optional so we don't care if its empty
      return ObjectParser.hasEmptyFields(obj)
    },
    async handleEdit(): Promise<void> {
      try {
        await this.$axios.put(`center/${this.selectedCenter.id}`, this.center)
        this.$toast.success('Center successfully edited')
        this.$emit('edited')
      } catch (e) {
        this.$toast.error(e.response.data.message)
      }
    },
    async handleDeleteCenter(): Promise<void> {
      const confirmationText = 'Are you sure you want to delete this center?'
      const confirmationPrompt =
        'Type the name of the center you want to delete: '
      const centerName = window.prompt(confirmationPrompt)
      if (centerName !== this.center.name) {
        this.$toast.error('Wrong center name.')
        return
      }
      if (window.confirm(confirmationText)) {
        // PERMANENTLY DELETE the center
        try {
          await this.$axios.delete(`center/${this.selectedCenter.id}`)
          this.$emit('deleteCenter', this.selectedCenter)
          this.$emit('input', false)
        } catch (e) {
          this.$toast.error(
            'Unable to delete center. Ensure that no clinical trials and users (including yourself) are tied to the center.'
          )
        }
      }
    }
  },
})
